import { UserAuditLogEntry } from 'apis/auditLogs';

import { CardField, UserActivityCard } from './userActivityCard';
import { humanize, statusColors } from './userActivityTypes.utils';

type UserUnbannedProps = {
  entry: UserAuditLogEntry<'USER_UNBANNED'>;
};

export const UserUnbanned = ({ entry }: UserUnbannedProps): JSX.Element => {
  const channels = entry.channel_ref.map(humanize).join(', ');
  const fields: CardField[] = [{ label: 'Reason', value: entry.reason }].filter(
    (field) => field.value,
  );

  return (
    <UserActivityCard
      entry={entry}
      icon="check-circle"
      color={statusColors.positive}
      title="Unbanned"
      summary={channels || undefined}
      fields={fields}
    />
  );
};
